import moment from "jalali-moment";

const convertToShamsi = (dateInMiladi) => {
    return moment.from(`${dateInMiladi}`, "YYYY-MM-DD").locale("fa").format("YYYY-MM-DD")
}
const convertToMiladi = (dateInShamsi) => {
    return moment.from(`${dateInShamsi}`, "fa", "YYYY-MM-DD").format("YYYY-MM-DD")
}



export {
    convertToShamsi,
    convertToMiladi
}